<template>
    <div class="item-box">
        <div class="item title">{{ title }}</div>
        <div class="item date">2021-7-26</div>
    </div>
</template>

<script>
export default {
    props: ['title']
}
</script>

<style scoped>
.item-box{
    color: #f9fde4;
    font-size: 14px;
    height: 44px;
    line-height: 44px;
    /* padding: 16px; */
    display: flex;
    justify-content: space-between;
    /* border-bottom: 1px solid #a4b1e8; */
    /* width: 94%; */
    padding: 0 20px;
    margin: 0 auto;
}
.item-box:nth-child(even){
    background-color: #252a50;
}
.item-box:nth-child(odd){
    background-color: #141728;
}
.item-box .date{
    color: #f9fde4;
}
.item{
    display: inline-block;
}
</style>


// WEBPACK FOOTER //
// src/components/mjwy/home/ArticleListItem.vue